// NavLink.tsx (ganti isi file lama)
import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

interface NavLinkProps {
  href?: string;
  id?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
  activeColor?: string;
  inactiveColor?: string;
  className?: string;
  target?: string;
}

export const NavLink: React.FC<NavLinkProps> = ({
  href,
  children,
  style,
  id,
  activeColor = 'text-accelist-green',
  inactiveColor = 'text-black',
  className = '',
  target,
}) => {
  const router = useRouter();

  function getAnchorClassNames() {
    if (id === 'footerList') {
      if (href && href === router.pathname) return activeColor;
      return inactiveColor;
    }

    if (!href) return inactiveColor;

    if (href === '/') {
      return router.pathname === '/' ? activeColor : inactiveColor;
    }

    return router.pathname.startsWith(href) ? activeColor : inactiveColor;
  }

  const isExternal = href ? /^https?:\/\//.test(href) : false;
  const finalTarget = target ?? (isExternal ? '_blank' : undefined);
  const finalRel = finalTarget === '_blank' ? 'noopener noreferrer' : undefined;

  return (
    <Link
      href={href ?? '#'}
      className={`${className} ${getAnchorClassNames()}`}
      style={style}
      target={finalTarget}
      rel={finalRel}
    >
      {children}
    </Link>
  );
};
